import request from '@/utils/request'

let HdepartApi = {

  /*科室列表*/
  list(data) {
    return request._post('/shop/plus.hdepart.Index/index', data);
},
/*添加科室*/
add(data) {
    return request._post('/shop/plus.hdepart.Index/add', data);
},
/*修改科室*/
edit(data) {
    return request._post('/shop/plus.hdepart.Index/edit', data);
},
/*删除科室*/
del(data) {
    return request._post('/shop/plus.hdepart.Index/del', data);
},
/*科室详情*/
detail(data) {
  return request._post('/shop/plus.hdepart.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.hdepart.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.hdepart.Setting/getSetting', data, errorback);
    },
      /*修改部分数据*/
editPart(data) {
    return request._post('/shop/plus.hdepart.Index/editPart', data);
},
}
export default HdepartApi;



// WEBPACK FOOTER //
// ./src/api/hdepart.js